// assets/lazy-load.js
if (!window.LazyLoader) {
  class LazyLoader {
    constructor() {
      this.observer = null;
      this.init();
    }

    init() {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadImage(entry.target);
              this.observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '50px 0px',
          threshold: 0.1
        });
      }
      
      this.startObserving();
    }

    loadImage(img) {
      const src = img.dataset.src;
      if (!src) return;

      const tempImg = new Image();
      tempImg.onload = () => {
        img.src = src;
        img.classList.remove('lazyload');
        img.classList.add('lazyloaded', 'animate-fade-in');
        
        img.removeAttribute('data-src');
      };
      
      tempImg.onerror = () => {
        console.warn('Error cargando imagen:', src);
        img.src = '/assets/no-image.jpg';
      };
      
      tempImg.src = src;
    }

    startObserving() {
      document.querySelectorAll('.lazyload').forEach(img => {
        if (this.observer) {
          this.observer.observe(img);
        } else {
          this.loadImage(img);
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new LazyLoader();
  });
}
